import React from 'react';
import { Reveal, SectionLabel } from './Section';
import { OVERVIEW_CARDS, LEARN_ITEMS } from '../data/content';
import { Database, LineChart, LayoutDashboard, Bot } from 'lucide-react';

export default function Overview() {
  return (
    <>
      <section id="overview" className="py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal>
            <SectionLabel>The Program</SectionLabel>
            <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[72px] leading-[1.02] font-semibold text-[#293891] mt-6 max-w-3xl">
              Built for the <span className="text-[#E63329]">AI era</span> of data.
            </h2>
          </Reveal>

          <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 mt-14 items-start">
            <Reveal delay={0.1}>
              <p className="text-[15px] leading-relaxed text-[#293891]/75 max-w-md">
                Graduates, final-year students, career switchers and working professionals ready to build or advance a career in Data Science, Machine Learning & AI.
              </p>
            </Reveal>

            <div className="bg-white rounded-3xl border border-[#293891]/10 p-6 lg:p-10 grid sm:grid-cols-2 gap-8">
              {OVERVIEW_CARDS.map((c,i) => (
                <Reveal key={c.num} delay={i*0.08}>
                  <div>
                    <div className="big-num text-[64px] leading-none">{c.num}</div>
                    <h3 className="font-display text-[22px] font-semibold text-[#293891] mt-3">{c.title}</h3>
                    <p className="text-[13.5px] leading-relaxed text-[#293891]/70 mt-3">{c.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="pb-24 lg:pb-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal><SectionLabel>What You'll Learn</SectionLabel></Reveal>
          <div className="grid lg:grid-cols-[1.2fr_1fr] gap-8 mt-6 items-end">
            <Reveal>
              <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[68px] leading-[1.02] font-semibold text-[#293891]">
                From raw data to <span className="text-[#E63329]">intelligent decisions.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="text-[15px] leading-relaxed text-[#293891]/75 max-w-md">
                A complete Data Scientist skillset — the technical craft, the modelling depth, and the AI leverage that sets you apart.
              </p>
            </Reveal>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-14">
            {LEARN_ITEMS.map((l,i) => {
              const Icon = [Database, LineChart, LayoutDashboard, Bot][i];
              return (
                <Reveal key={l.title} delay={i*0.08}>
                  <div className="card-lift bg-white border border-[#293891]/10 rounded-3xl p-6 h-full">
                    <div className="w-12 h-12 rounded-2xl bg-[#293891]/8 flex items-center justify-center text-[#293891]" style={{background:'rgba(41,56,145,0.08)'}}>
                      <Icon size={22}/>
                    </div>
                    <h3 className="font-display text-[20px] font-semibold text-[#293891] mt-6">{l.title}</h3>
                    <p className="text-[13.5px] leading-relaxed text-[#293891]/70 mt-3">{l.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
